<div [innerHTML]="(this.description$ | async)?.value" [ngClass]="typographySize" class="chart-txt"></div>
